import { authRoles } from "../../../auth/authRoles";
import Data from "./Data/Data";
import EditData from "./Data/EditData";
import TambahData from "./Data/TambahData";
import Departement from "./Departement/Departement";
import EditDepartement from "./Departement/EditDepartement";
import TambahDepartement from "./Departement/TambahDepartement";

const karirRoutes = [
  {
    path: "/departement_karir/edit/:id",
    exact: true,
    component: EditDepartement,
    auth: authRoles.all,
  },
  {
    path: "/departement_karir/tambah",
    exact: true,
    component: TambahDepartement,
    auth: authRoles.all,
  },
  {
    path: "/departement_karir",
    exact: true,
    component: Departement,
    auth: authRoles.all,
  },
  {
    path: "/data_karir/edit/:id",
    exact: true,
    component: EditData,
    auth: authRoles.all,
  },
  {
    path: "/data_karir/tambah",
    exact: true,
    component: TambahData,
    auth: authRoles.all,
  },
  {
    path: "/data_karir",
    exact: true,
    component: Data,
    auth: authRoles.all,
  },
];

export default karirRoutes;
